import { Button, Typography } from '@breetometer/components';
import { IdentityVerification, RecoveryCodesExhaustedIcon } from 'BreetAssets';
import { Loader, ModalParts, RecoveryCodeForm } from 'BreetComponents';
import { useDialogVerifyTransaction } from 'BreetHooks';

import { verifyTransactionTitle } from './DialogVerifyTransaction.helpers';

const DialogVerifyTransaction = () => {
	const {
		formStage,
		skipPin,
		skipPinAndMfa,
		userPreferenceData,
		userPreferenceLoading,
		isApiloading,
		pinComponent,
		otpComponent,
		recoveryCodeValue,
		handleRecoveryCodeValue,
		submitRecoveryCode,
		handleOpenModal,
		closeVerification,
	} = useDialogVerifyTransaction();

	if (userPreferenceLoading) return <Loader />;

	if (skipPinAndMfa) return null;

	return (
		<ModalParts.Wrapper
			title={formStage.stageTitle}
			rightSheet
			root={verifyTransactionTitle[skipPin ? 'otp-verification' : 'pin-verification']}
			handleBackLink={formStage.navigator.historyBack}
			handleRootBackLink={closeVerification}
		>
			<ModalParts.Stage hide={!formStage.isStageActive('pin-verification')}>{pinComponent}</ModalParts.Stage>
			<ModalParts.Stage hide={!formStage.isStageActive('otp-verification')}>
				<div className='verify-transaction-otp'>
					<IdentityVerification />
					{otpComponent}
				</div>
			</ModalParts.Stage>
			<ModalParts.Stage hide={!formStage.isStageActive('recovery-code')}>
				<RecoveryCodeForm
					handleRecoveryCodeValue={handleRecoveryCodeValue}
					btnDisabled={recoveryCodeValue.length < 10}
					recoveryCodeValue={recoveryCodeValue}
					submitRecoveryCode={submitRecoveryCode}
					isLoading={isApiloading}
					userPreferenceData={userPreferenceData}
				/>
			</ModalParts.Stage>
			<ModalParts.Stage hide={!formStage.isStageActive('exhausted-recovery-code')}>
				<div className='exhausted-recovery-code'>
					<RecoveryCodesExhaustedIcon />

					<Typography
						as='h5'
						className='color-tertiary-400'
					>
						Recovery Code Exhausted
					</Typography>
					<Typography className='color-primary-100'>
						You&apos;ve used all available recovery codes. Contact support to regain access to reset.
					</Typography>

					<Button onClick={handleOpenModal({ id: 'contactSupport' })}>Contact Support</Button>
				</div>
			</ModalParts.Stage>
		</ModalParts.Wrapper>
	);
};

export default DialogVerifyTransaction;
